import { Auth } from "~/modules/auth/auth";

export default defineNuxtPlugin(() => {
  return {
    provide: {
      auth: new Auth(),
    },
  };
});
